module.exports = "../images/fishing-on-lake-home-1@2x.jpg?v=fdbc39a";